import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";

export const getAllConcepts = async (params?: any): Promise<any[]> => {
    try {
        const data = await getApi('/concept', params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const getByIdConcepts = async (id: number): Promise<any[]> => {
    try {
        const data = await getApi(`/concept/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const postNewConcepts = async (body: any): Promise<any> => {
    try {
        const data = await postApi(`/concept`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const patchConcepts = async (body: any, id?: number): Promise<any> => {
    try {
        const data = await patchApi(`/concept/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any[];
    }
}

export const deleteConcepts = async (id: number): Promise<any> => {
    try {
        const data = await deleteApi(`/concept/${id}`, {});
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}